// src/assets/categoryIcons/index.js
import { ReactComponent as Book } from './Book_Open.svg';
import { ReactComponent as Car } from './Car_Auto.svg';
import { ReactComponent as Coffe } from './Coffe_To_Go.svg';
import { ReactComponent as Card } from './Credit_Card_01.svg';
import { ReactComponent as Eat } from './Cupcake.svg';
import { ReactComponent as Gift } from './Gift.svg';
import { ReactComponent as Mail } from './Mail_Open.svg';
import { ReactComponent as Bag } from './Shopping_Bag_02.svg';
import { ReactComponent as Star } from './Star.svg';
import { ReactComponent as Sun } from './Sun.svg';
import { ReactComponent as TrendingUp } from './Trending_Up.svg';
import { ReactComponent as UserCheck } from './User_Check.svg';
import { ReactComponent as Alarm } from './Alarm.svg';
import { ReactComponent as Building } from './Building_03.svg';
import { ReactComponent as Bulb } from './Bulb.svg';
import { ReactComponent as Chart } from './Chart_Pie.svg';
import { ReactComponent as FileBlank } from './File_Blank.svg';
import { ReactComponent as FirstAid } from './First_Aid.svg';
import { ReactComponent as Globe } from './Globe.svg';
import { ReactComponent as Leaf } from './Leaf.svg';
import { ReactComponent as Map } from './Map.svg';
import { ReactComponent as Bag2 } from './Shopping_Bag_01.svg';
import { ReactComponent as Tag } from './Tag.svg';
import { ReactComponent as Ticket } from './Ticket_Voucher.svg';
import { ReactComponent as User } from './User_01.svg';

export const categoryIcons = {
  Star,
  Book,
  Sun,
  Globe,
  Map,

  Card,
  TrendingUp,
  Tag,
  Ticket,
  FileBlank,

  Bulb,
  Gift,
  Mail,
  Bag,
  Bag2,

  UserCheck,
  User,
  Building,
  Car,
  Alarm,

  Coffe,
  Eat,
  Chart,
  FirstAid,
  Leaf,

};
